import { useCallback, useSyncExternalStore } from 'react'

interface BreweryActionBarSnapshot {
  isOpen: boolean
  breweryName: string | null
}

let breweryActionBarState: BreweryActionBarSnapshot = {
  isOpen: false,
  breweryName: null,
}

const breweryActionBarSubscribers = new Set<() => void>()

const notifySubscribers = (): void => {
  breweryActionBarSubscribers.forEach((listener) => listener())
}

const subscribe = (listener: () => void): (() => void) => {
  breweryActionBarSubscribers.add(listener)
  return () => breweryActionBarSubscribers.delete(listener)
}

const getSnapshot = (): BreweryActionBarSnapshot => breweryActionBarState

export const openBreweryActions = (breweryName: string): void => {
  breweryActionBarState = {
    isOpen: true,
    breweryName,
  }
  notifySubscribers()
}

export const closeBreweryActions = (): void => {
  breweryActionBarState = {
    isOpen: false,
    breweryName: null,
  }
  notifySubscribers()
}

export const useBreweryActionBar = () => {
  const state = useSyncExternalStore(subscribe, getSnapshot, getSnapshot)

  const open = useCallback((breweryName: string) => {
    openBreweryActions(breweryName)
  }, [])

  const close = useCallback(() => {
    closeBreweryActions()
  }, [])

  return {
    ...state,
    openBreweryActions: open,
    closeBreweryActions: close,
  }
}
